class DiFioreForni
{
   constructor()
   {
      gsap.registerPlugin(ScrollTrigger);
      this.init();
   }

   init = () =>
   {
      this.setListeners();
      this.initializeGsap();
   }

   setListeners = () =>
   {
      return;
   }

   initializeGsap = () =>
   {
      const animatedElements = document.querySelectorAll('html:not(.shopify-design-mode) .animated');
      if (animatedElements.length > 0)
      {
         [...animatedElements].forEach(el =>
         {
            gsap.from(el, {
               scrollTrigger: {
                  start: 'top bottom',
                  end: 'bottom top',
                  once: true,
                  trigger: el,
                  onEnter: () => {
                     el.classList.add('animate');
                  }
               }
            });
         });
      }
   }
}

new DiFioreForni()